import { useState} from "react";
import { Table } from "antd";
import PropTypes from "prop-types";


function CbTable(props) {
  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [searchedColumn, setSearchedColumn] = useState("");

  return (
    <Table
      bordered
      size="middle"
      tableLayout="fixed"
      {...props}
      className="cb-table"
    />
  );
}

CbTable.propTypes = {
  columns: PropTypes.shape([]).isRequired,
};

export default CbTable;
